import { Injectable } from '@angular/core';
import { IFlagFeature } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class HideRoleReceivingPersonFeature implements IFlagFeature {
  name = Features.HIDE_ROLE_RECEIVING_PERSON;

  public isEnabled(container: any): boolean {
    return container[this.name].isEnabled();
  }
}
